import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import { useMemo } from 'react';
import BonusIndicator from 'modules/bonus-indicator/index.js';
import BonusIndicatorTypes from 'modules/bonus-indicator/types.js';

const BetsUtils = MojitoServices.Bets.utils;
const classUtils = MojitoCore.Base.classUtils;

const OddsBoostIndicator = props => {
    const { bet, mojitoTools } = props;
    const { config } = mojitoTools;
    const boost = BetsUtils.getOddsBoost(bet);
    const { value, contributionSource, oddsBoostSubtype } = boost || {};

    const bonusInfo = useMemo(
        () => ({ contributionSource, oddsBoostSubtype, value }),
        [contributionSource, oddsBoostSubtype, value]
    );

    if (value === undefined) {
        return null;
    }

    return (
        <BonusIndicator
            config={config.bonusIndicator}
            class={classUtils.classNames(`ta-OddsBoostIndicator`, props.class)}
            bonusType={BonusIndicatorTypes.TYPES.ODDS_BOOST}
            bonusInfo={bonusInfo}
        />
    );
};

export default OddsBoostIndicator;
